<template>

    <!-- 底部 -->
    <div class="container-fluid" style="position: fixed;bottom: 0;">
    <!-- <div class="container-fluid footer"> -->
        <div class="footer-top" v-if="false">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 footer-navs">
                        <p>
                            网站导航
                        </p><img src="/static/footer_01.png">
                        <div class="row">
                            <div class="col-md-6 footer-home-left">
                                <ul class="list-inline footer-nav">
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/">网站首页</a>
                                    </li>
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/">中小学招聘</a>
                                    </li>
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/">期刊查询系统</a>
                                    </li>
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/">知识产权服务</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-6 footer-home-right">
                                <ul class="list-inline footer-nav">
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/">教学工具</a>
                                    </li>
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/">教材专著出版</a>
                                    </li>
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/">支教信息</a>
                                    </li>
                                    <li>
                                        <a href="http://b.1.7cong.cn/#/" target="_blank">网站地图</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 footer-navs">
                        <p>
                            友情链接
                        </p><img src="/static/footer_01.png">
                        <ul class="list-inline footer-nav">
                            <li>
                                <a href="http://www.cqedu.cn/" target="_blank">重庆教育局</a>
                            </li>
                            <li>
                                <a href="http://www.0430.com" target="_blank">全球网站库</a>
                            </li>
                            <li>
                                <a href="http://www.kaoyanrj.com" target="_blank">考研日记</a>
                            </li>
                            <li>
                                <a href="http://www.pengpengseo.com/" target="_blank">seo网站优化</a>
                            </li>
                            <li>
                                <a href="http://b.1.7cong.cn/#/" target="_blank">出版网站</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-3 footer-navs">
                        <p>
                            联系我们
                        </p><img src="/static/footer_01.png">
                        <ul class="list-inline footer-nav footer-nav-address">
                            <li>联系我们：<span>023-6033 7421</span>
                            </li>
                            <li>联系地址：重庆市渝中区石油路时代天街11号楼16楼
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-2 footer-navs">
                        <img src="/static/footer-logo.png" style="width: 120px;">
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            Copyright © 2018-2021 酝智文化传媒 版权所有 网站备案信息：<a href="http://beian.miit.gov.cn" target="_blank">蜀ICP备18013254号</a>
        </div>
    </div>

</template>

<script>
export default {
  name: 'footer-bar',

  data () {
    return {
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue